<template>
  <div class="sz-box" v-if="show" @click="show = false">
  	<div class="sz-box-model" @click.stop>
  		<div class="sz-box-model-title">
  			<span>{{$t('all.shezhi')}}</span>
			<img src="../../assets/image/wode_jiazu@2x.png" alt="" @click="show = false"/>
  		</div>
		<div class="sz-box-model-container">
			<div class="sz-box-model-container-left">
				<div :class="index===navListIndex?'sz-box-model-container-left-item':'sz-box-model-container-left-item1'" v-for="(item,index) in navList" :key="index" @click="handleNav(index)">
					<img class="sz-box-model-container-left-item-img" :src="item.img" alt="" />
					<span class="sz-box-model-container-left-item-span">{{item.name}}</span>
				</div>
			</div>
			<div class="sz-box-model-container-right">
				<div class="sz-box-model-container-right-box" v-if="navListIndex == 0">
					<div class="sz-title">{{$t('all.yuyanxuanze')}}</div>
					<div class="sz-yyxz-list">
						<div :class="index===yyListIndex?'sz-yyxz-list-item':'sz-yyxz-list-item1'" v-for="(item,index) in yyList" @click="handleChooseYy(index,item.language)">{{item.name}}</div>
					</div>
				</div>
				<div class="sz-box-model-container-right-box" v-if="navListIndex == 1">
					<div class="sz-title">{{$t('all.xiugaimima')}}</div>
					<div class="sz-xgmm">
						<div class="box-input">
							<img class="box-input-img" src="../../assets/image/denglu_mima@2x.png" alt="" />
							<input autocomplete="new-password" class="box-input-input" v-if="!isOldPassword" v-model="form.oldPassword" type="text" :placeholder="$t('all.qingshurujiumima')" placeholder-style="color:rgba(255,255,255,0.6)"/>
							<input autocomplete="new-password" class="box-input-input" v-if="isOldPassword" v-model="form.oldPassword" type="password" :placeholder="$t('all.qingshurujiumima')" placeholder-style="color:rgba(255,255,255,0.6)"/>
							<img class="box-input-img" src="../../assets/image/denglu_yincang@2x.png" alt="" v-if="isOldPassword" @click="isOldPassword = !isOldPassword"/>
							<img class="box-input-img" src="../../assets/image/denglu_yulan@2x.png" alt="" v-if="!isOldPassword" @click="isOldPassword = !isOldPassword"/>
						</div>
						<div class="box-input">
							<img class="box-input-img" src="../../assets/image/denglu_mima@2x.png" alt="" />
							<input autocomplete="new-password" class="box-input-input" v-if="!isPassword" v-model="form.password" type="text" :placeholder="$t('all.qingshuruxinmima')" placeholder-style="color:rgba(255,255,255,0.6)"/>
							<input autocomplete="new-password" class="box-input-input" v-if="isPassword" v-model="form.password" type="password" :placeholder="$t('all.qingshuruxinmima')" placeholder-style="color:rgba(255,255,255,0.6)"/>
							<img class="box-input-img" src="../../assets/image/denglu_yincang@2x.png" alt="" v-if="isPassword" @click="isPassword = !isPassword"/>
							<img class="box-input-img" src="../../assets/image/denglu_yulan@2x.png" alt="" v-if="!isPassword" @click="isPassword = !isPassword"/>
						</div>
						<div class="sz-xgmm-des">{{$t('all.mimashuoming')}}</div>
						<div class="sz-xgmm-btn" @click="updatePassWord">{{$t('all.quedingxiugai')}}</div>
					</div>
				</div>
				<div class="sz-box-model-container-right-box" v-if="navListIndex == 2">
					<div class="sz-title">{{$t('all.yinsizhengce')}}</div>
					<div class="sz-yszc">{{data}}</div>
				</div>
				<div class="sz-box-model-container-right-box" v-if="navListIndex == 3">
					<div class="sz-title">{{$t('all.guanyuwomen')}}</div>
					<<div class="sz-gywm">
						<img class="box-input-img" src="../../assets/image/logo.png" alt="" />
					</div>
				</div>
			</div>
		</div>
  	</div>
  </div>
</template>

<script>
import { updatePassWord,getHtmlContentByType } from '@/api/user';
export default {
  data() {
    return {
	  show:false,
	  navList:[{
		  img:'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1767688018165_oj1l4sf0cy.png',
		  name:this.$t('all.yuyanxuanze')
	  },{
		  img:'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1767688073263_tqfg1nieeam.png',
		  name:this.$t('all.xiugaimima')
	  },{
		  img:'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1767688100314_5kqt1l5o5tf.png',
		  name:this.$t('all.yinsizhengce')
	  },{
		  img:'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1767688115602_hte1guphbwo.png',
		  name:this.$t('all.guanyuwomen')
	  }],
	  navListIndex:0,
	  yyList:[{
		  name:this.$t('all.jiantizhongwen'),
		  language:'cn'
	  },{
		  name:this.$t('all.fantizhongwen'),
		  language:'tw'
	  },{
		  name:this.$t('all.yingwen'),
		  language:'en'
	  },{
		  name:this.$t('all.ribenyu'),
		  language:'ja'
	  },{
		  name:this.$t('all.hanguoyu'),
		  language:'ko'
	  }],
	  yyListIndex:0,
	  form:{
		password:'',
		oldPassword:''
	  },
	  isPassword:true,
	  isOldPassword:true,
	  data:''
    };
  },
  mounted() {
	  const lang = localStorage.getItem('Language')
	  this.yyListIndex = lang==='cn'?0 : lang==='tw'?1 : lang==='en'?2 : lang==='ja'?3:4
  },
  methods: {
	showModel(){
		this.show = true
	},
	//选择nav
	handleNav(index){
		this.navListIndex = index
		if(index == 2){
			this.getHtmlContentByType()
		}
	},
	//选择语言
	handleChooseYy(index,language){
		this.yyListIndex = index
		this.$i18n.locale = language;
		localStorage.setItem("Language",language);
		let langStr = 'chinese'
		if(language === 'en') langStr = 'english'
		else if(language === 'tw') langStr = 'taiwan'
		else if(language === 'ja') langStr = 'japanese'
		else if(language === 'ko') langStr = 'korean'
		this.$store.commit('changeLanguage', langStr);
		window.location.reload();
	},
	//修改密码
	async updatePassWord(){
		const res = await updatePassWord(this.form)
		this.$message({ message: res.msg,type: 'success'});
		this.form = {
			password:'',
			oldPassword:''
		}
	},
	//静态页面
	async getHtmlContentByType(){
		const res = await getHtmlContentByType({type:2})
		this.data = res.data
	}

  }
};
</script>
<style scoped lang="scss">
	@import "./shezhi.css";
</style>


// WEBPACK FOOTER //
// shezhi.vue?e9d2efce